<template>
    <form @submit.stop.prevent="getUserExpenditures">
    <div class="table-responsive">
        <table class="table">
            <thead>
                <tr>
                <th>USERNAME</th>
                <th>FULL NAME</th>
                <th>SCANNED QTY</th>
                <th>FUNDS</th>
                <th>SPENT</th>
            </tr>
                <tr>
                <th><input type="text" class="form-control" v-model="expSearchModel.name_user"/></th>
                <th><input type="text" class="form-control" v-model="expSearchModel.fullname_user"/></th>
                <th><input type="text" class="form-control" v-model="expSearchModel.scannedqty"/></th>
                <th><input type="text" class="form-control" v-model="expSearchModel.funds"/></th>
                <th><input type="text" class="form-control" v-model="expSearchModel.spent"/><button class="d-none" type="submit"></button></th>
                </tr>

            </thead>
            <tbody>
                <tr v-for="ux in userExpenditures" :key="ux.syspk_user">
                    <td>{{ ux.name_user }}</td>
                    <td>{{ ux.fullname_user }}</td>
                    <td>{{ ux.scannedqty }}</td>
                    <td>{{ ux.funds }}</td>
                    <td>{{ ux.spent }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</form>
</template>

<script setup>
import userService from '@/services/userService';
import { onMounted, ref } from 'vue';

const userExpenditures = ref([]);
const expSearchModel = ref({name_user: ""})
const getUserExpenditures = async ()=>{
    userExpenditures.value = await userService.searchUserExpenditures(expSearchModel.value);
};

onMounted(()=>{
    getUserExpenditures();
});

</script>